// TODO from Nikola: the res suffix is used for API responses
export const trendingTickersRes = (state) => state.trendingTickers;
export const trendingGainersTickersRes = (state) =>
  state.trendingGainersTickers;
export const trendingLosersTickersRes = (state) => state.trendingLosersTickers;
